import React from 'react';
import { businessServices } from '../../data/businessServices';
import ServiceSection from '../../components/ServiceSection';
import Hero from '../../components/Hero';

const Hosting = () => {
  const hostingService = businessServices.find(service => service.title === "Hosting & Cloud");

  return (
    <>
      <Hero
        title="Hosting & Cloud"
        subtitle="Servicii de hosting și cloud pentru aplicațiile și datele companiei tale"
        variant="compact"
        ctaLabel="Vezi Tarife"
        ctaHref="#tarife"
        backgroundImageUrl="/img/hero-business-hosting.jpg"
        icon={hostingService?.icon}
        iconLabel={hostingService?.title}
      />

      {hostingService && (
        <ServiceSection
          service={hostingService}
          index={0}
          pricingFirst
          id="tarife"
          showTitleBlock={false}
        />
      )}
    </>
  );
};

export default Hosting;
